import DataTable from "react-data-table-component"
import Select from "react-select"
import debounce from "lodash.debounce"
import { useCallback } from "react"
import useSatkerPimpinan from "./useSatkerPimpinan"
import { useNavigate } from "react-router-dom"
import { useMemo } from "react"

const SatkerPimpinanPage = () => {
    const navigate = useNavigate()

    const {
        data,
        loading,
        selectedRows,
        satkerPimpinanOptions,
        filterSatker,
        setFilterSatker,
        fetchUsersBySatker,
        allSatkerOptions,
        selectedSatker,
        isSubmit,
        handleRowSelected,
        handleSubmitSatker,
        setSelectedSatker,
        getSatkerPimpinan, getAllSatker,
        satkerSearch,
        setSatkerSearch

    } = useSatkerPimpinan()

    const debouncedSearch = useCallback(
        debounce((val) => getSatkerPimpinan(val), 500),
        []
    )
    const debouncedGetSatker = useMemo(
        () => debounce((val) => getAllSatker(val), 500),
        []
    )
    const columns = [
        { name: "Nama", selector: (row) => row.nama },
        { name: "Email", selector: (row) => row.email },
        { name: "NIP", selector: (row) => row.nip }, {
            name: "List Satker Pimpinan",
            selector: (row) =>
                row.list_satker_pimpinan?.map(s => s.satuan_kerja).join(", ") || "-"
        }

    ]

    return (
        <>
            <div className="row" style={{ padding: "36px" }}>
                <div className="col-12">
                    <h1 className="d-flex justify-content-center mb-4 title-home">
                        Set Satker Pimpinan
                    </h1>

                    {/* ACTION BUTTONS */}
                    <div className="row justify-content-center mb-4">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="row">
                                <div className="col-6 d-flex justify-content-center">
                                    <div className="circle-button" onClick={() => navigate(-1)}>
                                        <i className="bi bi-arrow-left"></i>
                                        Back
                                    </div>
                                </div>

                                <div className="col-6 d-flex justify-content-center">
                                    <div
                                        className={`circle-button ${selectedRows.length !== 1 ? "disabled" : ""}`}
                                        data-bs-toggle="modal"
                                        data-bs-target="#satkerModal"
                                    >
                                        <i className="bi bi-pencil"></i>
                                        Update
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 🔥 SATKER FILTER */}
                    <div className="row justify-content-center mb-4">
                        <div className="col-xl-6 col-lg-8 col-md-12">
                            {/* <label className="col-form-label">Filter Satker</label> */}
                            <Select
                                options={satkerPimpinanOptions}
                                value={filterSatker}
                                onChange={(val) => {
                                    setFilterSatker(val)
                                    fetchUsersBySatker(val?.value)
                                }}
                                onInputChange={(val, { action }) => {
                                    if (action === "input-change") debouncedSearch(val)
                                }}
                                placeholder="Cari & pilih satker..."
                                isClearable
                                filterOption={() => true}

                            />
                        </div>
                    </div>

                    {/* TABLE */}
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 mb-4">
                            <div className="rounded-4 card" style={{ paddingBottom: "16px" }}>
                                <DataTable
                                    customStyles={{
                                        headCells: {
                                            style: { fontWeight: "bold", fontSize: "16px" },
                                        },
                                    }}
                                    columns={columns}
                                    data={data}
                                    progressPending={loading}
                                    selectableRows
                                    selectableRowsSingle
                                    onSelectedRowsChange={handleRowSelected}
                                    pagination
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL unchanged */}
            <div className="modal fade" id="satkerModal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Set Satker Pimpinan {selectedRows[0]?.nama || ""}
                            </h5>
                            <button className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div className="modal-body">
                            <label className="col-form-label">Pilih Satker</label>
                            <Select
                                isMulti
                                options={allSatkerOptions}
                                value={selectedSatker}
                                onChange={setSelectedSatker}

                                inputValue={satkerSearch}
                                onInputChange={(val, meta) => {
                                    if (meta.action === "input-change") {
                                        setSatkerSearch(val)
                                        debouncedGetSatker(val)
                                    }
                                }}
                                filterOption={() => true}

                                isLoading={loading}   // optional nice UX
                                placeholder="Cari satker..."
                                noOptionsMessage={() => "Ketik untuk mencari"}
                            />


                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-outline-primary"
                                onClick={handleSubmitSatker}
                                disabled={isSubmit}
                            >
                                {isSubmit ? "Menyimpan..." : "Simpan"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SatkerPimpinanPage
